import {
  LOADING_PROJECT,
  LOADING_ROUTES_LIST,
  LOADING_IMPORT,
  LOADING_UNSCHEDULED,
  LOADING_EDIT_STOP,
  SET_DRIVERS_LIST_LOADED,
  SET_VEHICLES_LIST_LOADED,
  LOADING_PROJECT_INITIAL,
  SET_DETERMINATE_LOADING,
  SET_TAGS_LIST_LOADED,
  SET_TEMPLATES_LIST_LOADED
} from "./types";

export function setLoadingProject(val) {
  return {
    type: LOADING_PROJECT,
    val
  };
}

export function setInitialProjectLoading(val) {
  return {
    type: LOADING_PROJECT_INITIAL,
    val
  };
}

export function setLoadingRoutesList(val) {
  return {
    type: LOADING_ROUTES_LIST,
    val
  };
}

export function setLoadingImport(val) {
  return {
    type: LOADING_IMPORT,
    val
  };
}

export function setLoadingUnscheduled(val) {
  return {
    type: LOADING_UNSCHEDULED,
    val
  };
}

export function setLoadingStop(val) {
  return {
    type: LOADING_EDIT_STOP,
    val
  };
}

export function setVehiclesListLoaded() {
  return {
    type: SET_VEHICLES_LIST_LOADED
  };
}

export function setTagsListLoaded() {
  return {
    type: SET_TAGS_LIST_LOADED
  };
}

export function setTemplatesListLoaded() {
  return {
    type: SET_TEMPLATES_LIST_LOADED
  };
}

export function setDriversListLoaded() {
  return {
    type: SET_DRIVERS_LIST_LOADED
  };
}

export function setDeterminateLoading(obj) {
  return {
    type: SET_DETERMINATE_LOADING,
    obj
  };
}
